export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14356.531731a0.jpg";